module.exports = "./img/desktop_logo.cffdacf.png";